import { useContext } from "react";
import { LoadingsContext } from "../contexts/loadings-context";

export const useLoadings = () => useContext(LoadingsContext);
